export default __webpack_public_path__ + "static/media/page8Image3.e8e579f0.jpeg";